<template>
  <div id="app">
    <vue-snotify></vue-snotify>
    <div class="toast" v-show="loading"><scale-loader :loading="loading"></scale-loader></div>
    <router-view/>
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.css' // or dark.css or simple.css
import { EventBus } from './event-bus.js'

export default {
  name: 'App',
  components: {
    Snotify,
    ScaleLoader
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
    EventBus.$on('show-loading', () => { this.loading = true })
    EventBus.$on('hide-loading', () => { this.loading = false })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin:0;
  padding:0;
  height:100%;
  width:100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue